export type DeckExceptionEventInit = {
  error: Error | AggregateError;
  detail: {
    reason: string;
    message?: string;
  };
};

export class DeckException extends CustomEvent<DeckExceptionEventInit["detail"]> {
  error: Error;

  constructor(type: string, deckEventInit: DeckExceptionEventInit) {
    super(type, {
      detail: deckEventInit.detail,
      bubbles: true, // required for event to bubble up to parent app
      cancelable: true,
      composed: true
    });

    this.error = deckEventInit.error;
  }
}
